// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__227ut","colMin":"styles_colMin__1vJhc"};